import { BlueButton } from "@react-solutions-ui/findmore-ui";
import { WhiteButton } from "@react-solutions-ui/findmore-ui";
import Dropdown from "../../../../employeeTeams/components/Filters/Dropdown";
import styles from "./MobileFilters.module.css";
import { CloseOutlined } from "@ant-design/icons";

interface MobileFiltersProps {
  onDismiss: () => void;
  onApply: () => void;
  states: string[];
  setSelectedState: (state: string) => void;
  selectedState: string;
  orderFilter: string;
  departments: string[];
  setSelectedDepartment: (department: string) => void;
  selectedDepartment: string;
  setOrderFilter: (order: string) => void;
  hasActiveFilters: boolean;
  sameFilters: boolean;
  handleClearFilters: () => void;
  lastAppliedFilters: string[];
}

export default function MobileFilters({
  onDismiss,
  onApply,
  states,
  setSelectedState,
  selectedState,
  departments,
  setSelectedDepartment,
  selectedDepartment,
  orderFilter,
  setOrderFilter,
  hasActiveFilters,
  sameFilters,
  handleClearFilters,
  lastAppliedFilters,
}: MobileFiltersProps) {
  return (
    <div>
      <div className={styles.mobileFiltersContainer}>
        <div className={styles.mobileFiltersHeader}>
          <h3 className={styles.mobileFiltersHeaderTitle}>Filtros</h3>
          <button
            className={styles.mobileFiltersHeaderCloseButton}
            onClick={() => {
              setSelectedState(lastAppliedFilters[0]);
              setSelectedDepartment(lastAppliedFilters[1]);
              setOrderFilter(lastAppliedFilters[3]);
              onDismiss();
            }}
          >
            <CloseOutlined
              style={{ fontSize: "20px", color: "rgb(19, 19, 19)" }}
            />
          </button>
        </div>
        <div className={styles.mobileFiltersContent}>
          <Dropdown
            label="Ordenar por"
            options={[
              "Nome (A-Z)",
              "Nome (Z-A)",
              "Data mais próxima",
              "Data mais distante",
            ]}
            selectedValue={orderFilter}
            onSelect={setOrderFilter}
          />
          <Dropdown
            label="Departamentos"
            options={departments}
            selectedValue={selectedDepartment}
            onSelect={setSelectedDepartment}
          />
          <Dropdown
            label="Estados"
            options={states}
            selectedValue={selectedState}
            onSelect={setSelectedState}
          />
        </div>
        <div className={styles.mobileFiltersFooter}>
          <WhiteButton
            className={`${styles.mobileFiltersFooterButton} ${styles.mobileFiltersFooterButtonWhite}`}
            text="Limpar filtros"
            onClick={() => {
              handleClearFilters();
            }}
            disabled={!hasActiveFilters}
          />
          <BlueButton
            className={styles.mobileFiltersFooterButton}
            text="Aplicar"
            onClick={() => {
              onApply();
            }}
            disabled={sameFilters}
          />
        </div>
      </div>
    </div>
  );
}
